<mat-dialog-content [class.main-container]="!tdodialog" style="padding: 10px;" data-cy="auth-patient-login">
  <mat-card appearance="outlined" [class.main-card]="!tdodialog" data-cy="auth-patient-login-card">
    <mat-card-header data-cy="auth-patient-login-header">
      <div mat-card-avatar class="tdo-login-header-image" data-cy="auth-patient-login-avatar"></div>
      <mat-card-title data-cy="auth-patient-login-title">TDO Login</mat-card-title>
      <mat-card-subtitle *ngIf="error" class="error-message" data-cy="auth-patient-login-error-message">
        {{this.error}}
      </mat-card-subtitle>
    </mat-card-header>

    <div class="spacer" data-cy="auth-patient-login-spacer">
      
    </div>

    <mat-card-content data-cy="auth-patient-login-content">
      <div class="inline-form"  *ngIf="!this.token" data-cy="auth-patient-login-username-form">
        <mat-label class="form-label" data-cy="auth-patient-login-username-label">Username</mat-label>
        <mat-form-field class="w-100" data-cy="auth-patient-login-username-field">
          <input matInput type="text" name="username" autocomplete="username"
                 maxlength="25" id="username" [(ngModel)]="username" value="{{username}}"
                 (keyup.enter)="RequestToken()"
                 required data-cy="auth-patient-login-username-input" />
        </mat-form-field>
      </div>
      <div class="inline-form" *ngIf="this.token" data-cy="auth-patient-login-code-form">
        <mat-label class="form-label" data-cy="auth-patient-login-code-label">Access Code</mat-label>
        <mat-form-field class="w-100" data-cy="auth-patient-login-code-field">
          <input matInput type="text" name="password" autocomplete="password"
                 maxlength="25" id="password" [(ngModel)]="password" value="{{password}}"
                 (keyup.enter)="onLoginPressed()"
                 required data-cy="auth-patient-login-code-input" />
        </mat-form-field>
      </div>

    </mat-card-content>
    <mat-card-actions data-cy="auth-patient-login-actions">
      <div fxFlex data-cy="auth-patient-login-flex"></div>
      <div style="margin: auto;" data-cy="auth-patient-login-buttons">
        <button *ngIf="!this.token" mat-button style="margin-bottom: 14px; margin-left: 8px;" class="tdo-button tdo-save" (click)="RequestToken()" type="submit" [disabled]="isLoading" data-cy="auth-patient-login-send-code-btn">
          <span *ngIf="!isLoading" data-cy="auth-patient-login-send-code-text">Send Code</span>
          <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-patient-login-send-code-spinner"></mat-spinner>
        </button>
        <button *ngIf="this.token" mat-button style="margin-bottom: 14px; margin-left: 8px;" class="tdo-button tdo-save" (click)="onLoginPressed()" type="submit" [disabled]="isLoading" data-cy="auth-patient-login-login-btn">
          <span *ngIf="!isLoading" data-cy="auth-patient-login-login-text">Login</span>
          <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-patient-login-login-spinner"></mat-spinner>
        </button>
        <button mat-button style="margin-bottom: 14px; margin-left: 8px;" class="tdo-button tdo-save" (click)="onCancelPressed()" [disabled]="isLoading" data-cy="auth-patient-login-cancel-btn">
          <span *ngIf="!isLoading" data-cy="auth-patient-login-cancel-text">Cancel</span>
          <mat-spinner class="login-spinner" *ngIf="isLoading" [diameter]="20" data-cy="auth-patient-login-cancel-spinner"></mat-spinner>
        </button>
        <div *ngIf="this.token" style="text-align: center; font-size: small;cursor: pointer; margin-top: 5px;" (click)="RequestToken(); return;" data-cy="auth-patient-login-resend-code">Resend Code</div>
      </div>
    </mat-card-actions>

  </mat-card>
</mat-dialog-content>
